import { Link } from "react-router-dom"
import DashboardSideBar from "../../components/dashboardSidebar"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import services from "../../services"
import { useEffect, useState } from "react"
import moment from "moment";
import { isMobile } from 'react-device-detect';
import constant from "../../constant"
import { TripTypeBadge, KmBadge, CostHighlight } from "../../components/bookingMeta";
import useIsMobile from "../../hooks/useIsMobile";
import MobileFooter from "../../components/MobileFooter";
import MobileHeader from "../../components/MobileHeader";

const MyBookings = () => {
    const isMobileView = useIsMobile();
    const [bookingList, setBookingList] = useState([])
    const [oneWayList, setOneWayList] = useState([])
    const [tab, setTab] = useState('oneway') // 'cab' | 'oneway'
    useEffect(() => {
        getBookingsHandler();
        getOneWayBookingsHandler();
    }, [])
    const getOneWayBookingsHandler = async () => {
        try {
            const response = await services.Vendor.GET_MY_ONE_WAY_BOOKINGS();
            setOneWayList(Array.isArray(response.data) ? response.data : [])
        } catch (error) {
            console.log(error)
        }
    }
    const getBookingsHandler = async () => {
        try {
            const response = await services.order.BOOKING_LISTING();
            console.log(response)
            let data = response.data;
            if (data.length) {
                data.map((item) => {
                    item.BookingDetails.sort(function (a, b) {
                        return parseFloat(a.id) - parseFloat(b.id);
                    });
                })
                data.sort(function (a, b) {
                    return parseFloat(b.id) - parseFloat(a.id);
                });
                setBookingList(data)
            }
        } catch (error) {
            console.log(error)
        }
    }
    if (isMobileView) {
        return (
            <>
                <SideBar />
                <main className="mlux">
                    <MobileHeader right={<Link to="/" className="mlux-avatar"><i className="fas fa-gauge-high"></i></Link>} />
                    <div className="mlux-greet" style={{ margin: '8px 4px 2px' }} data-rise="1">
                        <div className="kick">Your trips</div>
                        <div className="nm" style={{ fontSize: 24 }}>My Bookings</div>
                    </div>

                    <div className={`mlux-seg ${tab === 'oneway' ? 'two' : ''}`} data-rise="1" style={{ marginBottom: 14 }}>
                        <span className="thumb" />
                        <button className={tab === 'cab' ? 'on' : ''} onClick={() => setTab('cab')}><i className="fas fa-taxi"></i> Cab bookings</button>
                        <button className={tab === 'oneway' ? 'on' : ''} onClick={() => setTab('oneway')}><i className="fas fa-route"></i> One-way</button>
                    </div>

                    {tab === 'oneway' ? (
                        oneWayList.length ? oneWayList.map((item) => {
                            const av = item.vendorOneWayAvailability || {};
                            const car = av.vendorCar?.Car || {};
                            const name = item.userName || [item.user?.firstName, item.user?.lastName].filter(Boolean).join(' ');
                            const phone = item.contactNumber || item.user?.phoneNumber || '';
                            return (
                                <Link to={`/oneWayAvailabilities/${av.id}`} className="mlux-card mlux-trip" key={item.id} data-rise="2" style={{ display: 'block', textDecoration: 'none', color: 'inherit' }}>
                                    <div className="thead">
                                        <div>
                                            <div className="car">{car.brand || 'One-way'} {car.name || 'cab'}</div>
                                            <div className="bid">One-way · {item.passengerCount || 1} pax{name ? ` · ${name}` : ''}</div>
                                        </div>
                                        <span className="status" style={{ color: '#16a34a', background: 'rgba(22,163,74,0.12)' }}>Confirmed</span>
                                    </div>
                                    <div className="mlux-date"><i className="far fa-calendar"></i>{av.tripDate ? moment(av.tripDate).format('ddd, DD MMM') : '—'}</div>
                                    <div className="mlux-route">
                                        <div className="pt from"><small>From</small>{av.from?.full_address || '—'}</div>
                                        <div className="pt to"><small>To</small>{av.to?.full_address || '—'}</div>
                                    </div>
                                    <div className="tmeta" style={{ alignItems: 'center' }}>
                                        {av.estimatedFare != null && <span className="cost" style={{ color: '#16a34a', fontWeight: 800 }}>Est. ₹{Math.round(av.estimatedFare)}</span>}
                                        {phone && (
                                            <button
                                                type="button"
                                                className="mlux-callbtn sm"
                                                style={{ marginLeft: 'auto' }}
                                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); window.location.href = `tel:${String(phone).replace(/[^\d+]/g, '')}`; }}
                                            >
                                                <i className="fas fa-phone"></i> Call customer
                                            </button>
                                        )}
                                    </div>
                                </Link>
                            );
                        }) : (
                            <div className="mlux-card mlux-empty" data-rise="2">
                                <div className="ic"><i className="fas fa-route"></i></div>
                                <h4>No one-way bookings yet</h4>
                                <p>One-way trips confirmed by customers will appear here.</p>
                            </div>
                        )
                    ) : (
                    bookingList && bookingList.length ? bookingList.map((item) => (
                        <Link to={`/booking/${item.id}`} className="mlux-card mlux-trip" key={item.id} data-rise="2" style={{ display: 'block', textDecoration: 'none', color: 'inherit' }}>
                            <div className="thead">
                                <div>
                                    <div className="car">{item.Car?.brand} {item.Car?.name}</div>
                                    <div className="bid">Booking #{item.id}</div>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 8 }}>
                                    <span className="status">{item.BookingDetails?.[0]?.bookingStatus}</span>
                                    {(['confirmed', 'accepted', 'started', 'ended'].includes(item.BookingDetails?.[0]?.bookingStatus) || item.tripType === 'twoway') && item.BookingDetails?.[0]?.customerData?.phoneNumber && (
                                        <button
                                            type="button"
                                            className="mlux-callbtn sm"
                                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); window.location.href = `tel:${item.BookingDetails[0].customerData.phoneNumber}`; }}
                                        >
                                            <i className="fas fa-phone"></i> Call
                                        </button>
                                    )}
                                </div>
                            </div>
                            <div className="mlux-date"><i className="far fa-calendar"></i>{moment(item.tripStartDate).format('ddd, DD MMM')}</div>
                            <div className="mlux-route">
                                <div className="pt from"><small>From</small>{item?.BookingDetails?.[0]?.pickupLocation?.addressLine}</div>
                                <div className="pt to"><small>To</small>{item?.BookingDetails?.[0]?.dropLocation?.addressLine}</div>
                            </div>
                            <div className="tmeta">
                                <TripTypeBadge tripType={item.tripType} />
                                <KmBadge item={item} />
                                <span className="cost"><CostHighlight item={item} /></span>
                            </div>
                        </Link>
                    )) : (
                        <div className="mlux-card mlux-empty" data-rise="2">
                            <div className="ic"><i className="far fa-calendar"></i></div>
                            <h4>No bookings yet</h4>
                            <p>Accepted trips for your cabs will appear here.</p>
                        </div>
                    )
                    )}
                </main>
                <MobileFooter />
            </>
        );
    }

    return (<>
        <Header />
        <SideBar />
        <main class="main">




            <div class="user-profile py-5">
                <div class="container">
                    <div class="row">
                        <DashboardSideBar />
                        <div class="col-lg-9">
                            <div class="user-profile-wrapper">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="user-profile-card">
                                            <div class="user-profile-card-header">
                                                <h4 class="user-profile-card-title">My Booking</h4>
                                                <div class="user-profile-card-header-right">
                                                    <div class="user-profile-search">
                                                        <div class="form-group">
                                                            <input type="text" class="form-control" placeholder="Search..." />
                                                            <i class="far fa-search"></i>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <ul class="nav nav-pills mb-3">
                                                <li class="nav-item"><button type="button" class={`nav-link ${tab === 'cab' ? 'active' : ''}`} onClick={() => setTab('cab')}>Cab bookings</button></li>
                                                <li class="nav-item"><button type="button" class={`nav-link ${tab === 'oneway' ? 'active' : ''}`} onClick={() => setTab('oneway')}>One-way</button></li>
                                            </ul>
                                            {tab === 'oneway' ? (
                                                <div class="table-responsive">
                                                    <table class="table text-nowrap">
                                                        <thead>
                                                            <tr>
                                                                <th>Cab Info</th>
                                                                <th>Trip Date</th>
                                                                <th>Pickup and drop</th>
                                                                <th>Customer</th>
                                                                <th>Passengers</th>
                                                                <th>Est. Fare</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {oneWayList.length ? oneWayList.map((item) => {
                                                                const av = item.vendorOneWayAvailability || {};
                                                                const car = av.vendorCar?.Car || {};
                                                                const name = item.userName || [item.user?.firstName, item.user?.lastName].filter(Boolean).join(' ');
                                                                return (
                                                                    <tr key={item.id}>
                                                                        <td><h6 class="mb-0">{car.brand} {car.name}</h6></td>
                                                                        <td>{av.tripDate ? moment(av.tripDate).format('DD/MM/YY') : '—'}</td>
                                                                        <td style={{ whiteSpace: 'normal', minWidth: 180 }}>
                                                                            <span>{av.from?.full_address || '—'}</span> <br />
                                                                            <span>{av.to?.full_address || '—'}</span>
                                                                        </td>
                                                                        <td>
                                                                            <span>{name || '—'}</span> <br />
                                                                            <span>{item.contactNumber || item.user?.phoneNumber || ''}</span>
                                                                        </td>
                                                                        <td>{item.passengerCount || 1}</td>
                                                                        <td>{av.estimatedFare != null ? `Rs. ${Math.round(av.estimatedFare)}` : '—'}</td>
                                                                        <td>
                                                                            <Link to={`/oneWayAvailabilities/${av.id}`}
                                                                                class="btn btn-outline-secondary btn-sm rounded-2"
                                                                                title="Details"><i class="far fa-eye"></i></Link>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            }) : (
                                                                <tr><td colSpan="7" class="text-center py-5">No one-way bookings yet</td></tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : isMobile ? <div class="container my-3">

                                                {bookingList?.map((item) => {
                                                    return (<Link to={`/booking/${item.id}`} class="card booking-card">
                                                        <div class="d-flex justify-content-between align-items-center">

                                                            <div class="booking-info">
                                                                <h6 className="mb-0">{item.Car.brand} {item.Car.name}</h6>
                                                                <span>Booking ID: #{item.id}</span>
                                                            </div>
                                                            <img src={constant.IMAGE_URL + item?.VendorCar.photos[0]} crossorigin="anonymous" class="rounded-circle" alt="Driver image" />
                                                        </div>
                                                        <div className="d-flex justify-content-between">
                                                            <div class="mt-1">
                                                                <span><strong>From : </strong>{item?.BookingDetails[0].pickupLocation.addressLine}</span> <br />
                                                                <span><strong>to : </strong>{item?.BookingDetails[0].dropLocation.addressLine}</span>
                                                            </div>
                                                            <div class="mt-1">
                                                                <span>{moment(item.tripStartDate).format('DD/MM/YY')}</span>
                                                                <p>{moment(item.tripEndDate).format('DD/MM/YY')}</p>
                                                            </div>
                                                        </div>

                                                        <div class="d-flex justify-content-between mt-2">
                                                            <span class={`badge badge-status badge-${(item.bookingStatus == 'failed' || item.bookingStatus == 'cancelled' || item.bookingStatus == 'rejected') ? 'danger' : 'primary'} text-capitalize`}>{(item.bookingStatus == 'failed' || item.bookingStatus == 'cancelled' || item.bookingStatus == 'rejected') ? item.bookingStatus : item.BookingDetails[0].bookingStatus}</span>
                                                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}><TripTypeBadge tripType={item.tripType} /><KmBadge item={item} /><CostHighlight item={item} /></span>
                                                        </div>
                                                    </Link>)
                                                })}



                                            </div>
                                                :
                                                <div class="table-responsive">
                                                    <table class="table text-nowrap">
                                                        <thead>
                                                            <tr>
                                                                <th className="">Cab Info</th>
                                                                <th>Journey Date</th>
                                                                <th>Pickup and drop</th>
                                                                <th>Trip / KM</th>
                                                                <th>Price</th>
                                                                <th>Status</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {bookingList?.map((item) => {
                                                                return (<tr key={item.id}>
                                                                    <td>
                                                                        <div class="table-list-info">
                                                                            <a href="#">
                                                                                {/* <img src="/assets/img/taxi/01.png" alt/> */}
                                                                                <div class="table-list-content">
                                                                                    <h6>{item.Car.brand} {item.Car.name}</h6>
                                                                                    <span>Booking ID: #{item.id}</span>
                                                                                </div>
                                                                            </a>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <span>{moment(item.tripStartDate).format('DD/MM/YY')}</span>
                                                                        <p>{moment(item.tripEndDate).format('DD/MM/YY')}</p>
                                                                    </td>
                                                                    <td>
                                                                        <span>{item?.BookingDetails[0].pickupLocation.addressLine}</span> <br />
                                                                        <span>{item?.BookingDetails[0].dropLocation.addressLine}</span>
                                                                        {/* <p>03:15 PM</p> */}
                                                                    </td>
                                                                    <td><div className="d-flex flex-column align-items-start" style={{ gap: '4px' }}><TripTypeBadge tripType={item.tripType} /><KmBadge item={item} /></div></td>
                                                                    <td><CostHighlight item={item} /></td>
                                                                    <td><span class={`badge badge-${(item.bookingStatus == 'failed' || item.bookingStatus == 'cancelled' || item.bookingStatus == 'rejected') ? 'danger' : 'primary'} text-capitalize`}>{(item.bookingStatus == 'failed' || item.bookingStatus == 'cancelled' || item.bookingStatus == 'rejected') ? item.bookingStatus : item.BookingDetails[0].bookingStatus}</span></td>
                                                                    <td>
                                                                        <Link to={`/booking/${item.id}`}
                                                                            class="btn btn-outline-secondary btn-sm rounded-2"
                                                                            data-bs-toggle="tooltip" title="Details"><i
                                                                                class="far fa-eye"></i></Link>
                                                                    </td>
                                                                </tr>)
                                                            })}

                                                        </tbody>
                                                    </table>
                                                </div>}

                                            <div class="pagination-area d-none">
                                                <div aria-label="Page navigation example">
                                                    <ul class="pagination my-3">
                                                        <li class="page-item">
                                                            <a class="page-link" href="#" aria-label="Previous">
                                                                <span aria-hidden="true"><i
                                                                    class="far fa-angle-double-left"></i></span>
                                                            </a>
                                                        </li>
                                                        <li class="page-item active"><a class="page-link" href="#">1</a>
                                                        </li>
                                                        <li class="page-item"><a class="page-link" href="#">2</a></li>
                                                        <li class="page-item"><a class="page-link" href="#">3</a></li>
                                                        <li class="page-item">
                                                            <a class="page-link" href="#" aria-label="Next">
                                                                <span aria-hidden="true"><i
                                                                    class="far fa-angle-double-right"></i></span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </main>
        <Footer />
    </>
    )
}
export default MyBookings